<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <!-- 左边 -->
        <div style="margin: 5px; float: right">
            <el-button size="mini" type="success" @click="openModel">添加院区视频</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="标题" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="pic" label="视频">
                <template v-slot="scope">
                    <img :src="scope.row.pic[0]"  width="90" height="90">
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="标题">
                        <el-input v-model="ruleForm.name" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>

                        <el-form-item label="视频">
                        <div>
                            <span v-if="!ruleForm.pic[0]" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.pic[0]" class="rounded"
                                style="width: 100px; height: 100px; cursor: pointer" @click="chooseImage" />
                        </div>
                    </el-form-item>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button @click="subForm" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    export default {
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                names: "",
                dialogVisible: false,
                ruleForm: {
                    name: "",

                    pic: [],

                },

                rules: {},
                projectId: null,
            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
            that.search();
        },
        methods: {
            search() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectShow/index", {
                            project_id: that.ruleForm.project_id,
                            type_id: 1,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableData = response.data.data;
                    })
                    .catch((error) => {});
            },

            chooseImage(param) {
                let data = param;
                this.app.chooseImage((res) => {
                 this.ruleForm.pic=[];
					this.ruleForm.pic.push(res[0].url);
                }, 1);
            },
            openModel() {
                let that = this;
                that.operateflag = "add";
                that.names = "新增";
                that.ruleForm.name = '';
                that.ruleForm.pic = [];
                that.dialogVisible = true;
            },
            subForm() {
                let that = this;

                let param = {
                    // id: 0,
                    project_id: '',
                    name: '',
                    pic: [],
                };
                let apiUrl ="/admin/lgProjectShow/Madd";
                param = that.ruleForm;
                param["type_id"] = 1;
                if (that.names == "编辑") {
                    param.id = that.ruleForm.id;
                    apiUrl="/admin/lgProjectShow/Medit";
                }
                axios
                    .post(apiUrl, param, {
                        token: true,
                    })
                    .then((response) => {
                        if (response.data.code == 200) {
                            that.search();
                            that.dialogVisible = false;
                        }
                    })
                    .catch((error) => {});
            },
            handleClick(row) {
                let that = this;
                that.operateflag = "edit";
                that.names = "编辑";
                that.ruleForm.id = row.id;
                that.ruleForm.project_id = that.ruleForm.project_id;
                that.ruleForm.name = row.name;
                                     that.ruleForm.pic=[];
                if(row.pic !=null){
                let dataPic = Object.values(row.pic);
                that.ruleForm.pic = dataPic;
                }
                that.dialogVisible = true;
            },
            deleteClick() {},

        },
    };
</script>

<style></style>